import { jsx as t } from "react/jsx-runtime";
import { forwardRef as m } from "react";
import { twMerge as a } from "tailwind-merge";
const l = m((r, o) => {
  const { className: e, children: s, ...d } = r;
  return /* @__PURE__ */ t(
    "div",
    {
      ref: o,
      className: a(
        "rounded-xl border border-solid border-gray-200 bg-white shadow-sm",
        e
      ),
      ...d,
      children: s
    }
  );
});
export {
  l as Box
};
